import React, {PureComponent} from 'react'

import {
  Text,
  View,
  StyleSheet
} from 'react-native'

const colors = {
  black: '#333',
  'dark gray': '#666',
  'dark red': '#900',
  'light red': '#f66',
  'dark green': '#393',
  'light green': '#3f6',
  brown: '#a63',
  yellow: '#ff6',
  'dark blue': '#339',
  'light blue': '#3cf',
  'dark magenta': '#c09',
  'light magenta': '#f47',
  'dark cyan': '#39a',
  'light cyan': '#6cf',
  gray: '#999',
  white: '#eee'
}

const styles = StyleSheet.create({
  bit: {
    marginRight: 4,
    lineHeight: '1.2em'
  },
  view: {
    flexDirection: 'row',
    padding: 2
  }
})

const Bit = ({style, children}) =>
  <Text style={[styles.bit, style]}>
    {children}
  </Text>

const StyledBit = ({fg, bg, style, children}) => {
  const relayStyle = {
    color: colors[fg],
    backgroundColor: colors[bg]
  }
  return (
    <Bit style={[style, relayStyle]}>
      {children}
    </Bit>
  )
}

const Bits = ({bits, style}) =>
  bits.map(({text, ...bit}, index) =>
    <StyledBit
      key={text + index}
      style={style}
      {...bit}>
      {text}
    </StyledBit>
  )

export default class Message extends PureComponent {
  render () {
    const {
      prefix,
      message
    } = this.props

    return (
      <View style={styles.view}>
        {prefix &&
          <Bits bits={prefix} />
        }

        {message &&
          <Bits bits={message} />
        }
      </View>
    )
  }
}
